import { ProgressIcon } from "@100mslive/hms-video-react";

const FullPageProgress = () => (
  <div className="h-full">
    <div className="flex justify-center h-full items-center">
      <ProgressIcon width="100" height="100" />
    </div>
  </div>
);

export default FullPageProgress;
